<!--
 * @Description: 菜单图标组件 - 支持SVG图标和Element Plus图标
-->
<template>
  <!-- Element Plus 图标 -->
  <el-icon v-if="isElementIcon" class="menu-icon">
    <component :is="elementIconName" />
  </el-icon>
  <!-- SVG 图标 -->
  <svg-icon v-else :icon-class="resolvedIcon" class="menu-icon" />
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  }
})

const instance = getCurrentInstance()

const titleIconMap = {
  '首页': 'lucide-layout-dashboard',
  '仪表盘': 'lucide-layout-dashboard',
  '应用管理': 'lucide-app-window',
  '应用列表': 'lucide-app-window',
  '工作台': 'lucide-layout-dashboard',
  '机构管理': 'lucide-building-2',
  '机构列表': 'lucide-building-2',
  '课程管理': 'lucide-book-open',
  '课件列表': 'lucide-book-open',
  '课包列表': 'lucide-package-open',
  '课件分类': 'lucide-layers',
  '课包分类': 'lucide-layers',
  '官方提供': 'lucide-package-open',
  '系统管理': 'lucide-settings',
  '用户管理': 'lucide-users-round',
  '角色管理': 'lucide-user-round',
  '菜单管理': 'lucide-blocks',
  '字典管理': 'lucide-database',
  '师生管理': 'lucide-graduation-cap',
  '教室管理': 'lucide-school',
  '设备管理': 'lucide-monitor-smartphone',
  '设备列表': 'lucide-monitor-smartphone',
  '帮助反馈': 'lucide-circle-question-mark',
  '用户反馈': 'message',
  '课程记录': 'lucide-clipboard-check',
  '课程-Comfy素材库管理': 'lucide-layers',
  '运营管理': 'lucide-chart-no-axes-combined',
  '功能管理': 'lucide-blocks',
  'AI音效库': 'lucide-audio-lines',
  '资源库': 'lucide-database',
  '账号列表': 'lucide-users-round',
  '老师列表': 'lucide-presentation',
  '学员列表': 'lucide-user-round',
  '导出记录': 'lucide-file-down',
}

const semanticIcon = computed(() => {
  if (titleIconMap[props.title]) return titleIconMap[props.title]
  if (props.title.includes('素材库')) return 'lucide-layers'
  if (props.title.includes('课程')) return 'lucide-book-open'
  if (props.title.includes('机构')) return 'lucide-building-2'
  if (props.title.includes('应用')) return 'lucide-app-window'
  if (props.title.includes('AI')) return 'lucide-bot'
  return ''
})

const resolvedIcon = computed(() => {
  return semanticIcon.value || props.icon || 'lucide-package-open'
})

// 判断是否为Element Plus图标
const isElementIcon = computed(() => {
  if (semanticIcon.value) return false
  if (!props.icon) return false

  // 检查图标是否为Element Plus图标（通过检查是否为已注册的全局组件）
  const app = instance?.appContext.app
  if (app && app.component(props.icon)) {
    return true
  }

  // 备用检查：Element Plus图标通常以大写字母开头
  return /^[A-Z][a-zA-Z]*$/.test(props.icon)
})

// Element Plus图标名称
const elementIconName = computed(() => {
  return isElementIcon.value ? props.icon : ''
})
</script>

<style scoped>
.menu-icon {
  flex: 0 0 18px;
  margin-right: 14px;
  width: 18px;
  height: 18px;
  font-size: 18px;
  vertical-align: -2px;
}
</style>
